import { Fragment } from 'react';
import styles from './descriptor.module.scss';
import ReactMarkDown from 'react-markdown';


interface DescriptorProps {
	value: string
}

export default function Descriptor({value}:DescriptorProps) {
	return (
    <div className={styles.default}>
      {<ReactMarkDown
        source={value}
        escapeHtml={false}
        renderers={{ paragraph: props => <Fragment children={props.children} /> }}
      />}
    </div>
	);
}